// client/src/components/pages/Geofencing/geofencingPaths.ts
//
// Addresses of the two LexiStar map pages (ST-00210): Live View, where the live map is, and
// the Geofences page, whose tab is in its query string. Kept apart from the pages so either can
// link to the other without importing it. ST-00318: the Trips tab is Replay's now
// (LexiStar/Replay/replayPaths); ?tab=trips here forwards there.

/** Live View — the live map, its own page since ST-00210 (was the Geofences Live Map tab). */
export const LIVE_VIEW_PATH = '/lexistar/live';

export const GEOFENCING_PATH = '/geofencing';

export type GeofencingTab = 'zones' | 'events' | 'analytics' | 'aerials';

/** The tabs in display order; the first is the one the page opens on. */
export const GEOFENCING_TABS: readonly GeofencingTab[] = ['zones', 'events', 'analytics', 'aerials'];

export const DEFAULT_GEOFENCING_TAB: GeofencingTab = 'zones';

/** `?tab=` values that meant the old Live Map tab; they now go to Live View. */
export const LIVE_TAB_PARAMS: ReadonlySet<string> = new Set(['map', 'live']);

/**
 * `?tab=` of the old Trips tab (ST-00159). Since ST-00318 the Trips tab is Replay's: the
 * address forwards to /lexistar/replay?tab=trips with its parameters (vehicle, from, to, trip,
 * hide, hideVehicle; a `trip` lands on the tab with that trip selected).
 */
export const LEGACY_TRIPS_TAB = 'trips';

export const isGeofencingTab = (value: string | null | undefined): value is GeofencingTab =>
  (GEOFENCING_TABS as readonly string[]).includes(value ?? '');

/**
 * The Events tab's own query parameter (ST-00269): `show` = all | alerts | open, the Show
 * filter it opens on (the Pending Alerts card opens it on Open alerts). Leaving the tab drops it.
 */
export const EVENTS_QUERY_KEYS = ['show'] as const;

/** The Events tab, on Open alerts (where the Pending Alerts cards lead). */
export const OPEN_ALERTS_PATH = `${GEOFENCING_PATH}?tab=events&show=open`;

/** The Geofences page address for a tab (Trips is Replay's: replayPaths.tripsTabPath). */
export function geofencingPath(tab: GeofencingTab): string {
  const params = new URLSearchParams();
  if (tab !== DEFAULT_GEOFENCING_TAB) params.set('tab', tab);
  const query = params.toString();
  return query ? `${GEOFENCING_PATH}?${query}` : GEOFENCING_PATH;
}
